const Continue = {
  print: () => 'continue'
};

module.exports = Continue;
